//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";

export default {
  props: {
    article: {},
  },
  data() {
    return { dense: true };
  },

  computed: {
    ...mapState("main", []),
  },

  methods: {
    ...mapActions("main", []),
  },
};
